import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import rootReducer from "./slices";
//import 'bootstrap/dist/css/bootstrap.min.css'
import { configureStore } from "@reduxjs/toolkit";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import OfflineMessage from "helpers/OfflineMessage/OffflineMessage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
export const store = configureStore({ reducer: rootReducer, devTools: true });
root.render(
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
          <OfflineMessage/>
          <ToastContainer position="top-right" autoClose={2000} />
      </BrowserRouter>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
